import React, { Component } from 'react';
import './style.sass';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';
import CommonTitle from '../../../common-components/common-title';
import CommonUsualText from '../../../common-components/common-usual-text';

class Results extends Component {
    render() {
        return (
            <ScrollAnimation animateIn="fadeIn" offset={100} animateOnce={true} duration={1.5}>
                <FullWrapper caseName="results" isMargin={false} smallPaddings={true}>
                    <CommonTitle>Выводы</CommonTitle>
                    <ScrollAnimation
                        animateIn="fadeIn"
                        offset={100}
                        animateOnce={true}
                        duration={1.5}
                    >
                        <CommonUsualText className="results__text-info">
                            Мы рады, что совместной работой с проектом мы можем развивать сообщество
                            игроков венчурного рынка и привлекать в него новых участников. Верим
                            и активно работаем над тем, чтобы AdVentureLand стал крупнейшим
                            сообществом, в котором стартапы получают инвестиции, как например
                            Educate Online, сделку по которому признали синдикатом года, благодаря
                            вкладу сообщества.
                        </CommonUsualText>
                    </ScrollAnimation>
                </FullWrapper>
            </ScrollAnimation>
        );
    }
}

export default Results;
